module.exports = __webpack_public_path__ + "static/media/leydeamnistia-bannerart.ec2adca0.jpg";